// Piloto do novo seletor de forma de pagamento (lista compacta + selo "Recomendado") na etapa "Confirmar" da página pública.
//
// Mesmo padrão de config/predictedEndFlags.ts: a lista de empresas fica no CÓDIGO e a decisão usa o id da empresa CARREGADA
// na página (resposta de /public/:slug) — nunca o usuário logado nem parâmetros da URL. Sem empresa identificada = visual original.
// companyIds: empresas liberadas; null = todas (a liberação geral depende de nova aprovação). enabled:false desliga tudo.
// Para reverter só o piloto: enabled:false (ou companyIds:[]) e publicar de novo.

export interface PaymentSelectorFlag {
  enabled: boolean;
  companyIds: number[] | null;
}

export const PAYMENT_SELECTOR_B_FLAG: PaymentSelectorFlag = { enabled: true, companyIds: [7] };

export function isPaymentSelectorBOn(companyId: unknown, flag: PaymentSelectorFlag = PAYMENT_SELECTOR_B_FLAG): boolean {
  if (!flag.enabled) return false;
  if (typeof companyId !== 'number' && typeof companyId !== 'string') return false;
  if (typeof companyId === 'string' && !/^\d+$/.test(companyId.trim())) return false;
  const id = Number(companyId);
  if (!Number.isInteger(id) || id <= 0) return false; // empresa não identificada: visual original
  return flag.companyIds === null ? true : flag.companyIds.includes(id);
}
